module.exports = __webpack_public_path__ + "img/maintenance-2.9df05ea5.png";